import { useMutation } from "@apollo/client";
import { useCallback } from "react";

import { gql } from "~/__generated__";

const FIELDWORKER_UPDATE = gql(`
    mutation FieldworkerFinishOnboarding($input: GqlFieldworkerFinishOnboardingInput!) {
         fieldworkerFinishOnboarding(input: $input) {
            id
            userId
            isMyWheelsUser
            hasFinishedOnboarding
            hasOwnTransport
            address
        }
    }
`);

export type FieldworkerOnboardingParams = {
    addressId?: string;
    hasOwnTransport: boolean;
    hasDriversLicense: boolean;
    is21YearsOrOlder: boolean;
    hasDriversLicenseForMoreThan1Year: boolean;
};

export default function useFieldworkerFinishOnboarding() {
    const [fieldworkerFinishOnboarding, { data, loading, error }] = useMutation(FIELDWORKER_UPDATE, {
        refetchQueries: ["MeGetUserInfo", "AppDashboardGetComponents"],
    });

    return {
        fieldworkerFinishOnboarding: useCallback(
            (fieldworker: FieldworkerOnboardingParams) => {
                return fieldworkerFinishOnboarding({
                    variables: {
                        input: fieldworker,
                    },
                });
            },
            [fieldworkerFinishOnboarding],
        ),
        data,
        loading,
        error,
    };
}
